import {
  CLIENT_LIST,
  CLIENT_CREATE,
  CLIENT_FILTER,
  CLIENT_CREATE_SUCCESS,
  CLIENT_LIST_SUCCESS,
  CLIENT_REQUEST_FAILED,
  CLIENT_UPDATE,
  CLIENT_UPDATE_SUCCESS,
} from "store/clients/actionTypes";

const initialState = {
  clients: [],
  clientCreated: {},
  clientUpdated: {},
  loading: false,
  error: "",
};

const client = (state = initialState, action) => {
  switch (action.type) {
    case CLIENT_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CLIENT_CREATE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CLIENT_FILTER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CLIENT_UPDATE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CLIENT_LIST_SUCCESS:
      state = {
        ...state,
        loading: false,
        clients: action.payload,
        clientCreated: {},
        clientUpdated: {},
        error: "",
      };
      break;
    case CLIENT_CREATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        clientCreated: action.payload,
        error: "",
      };
      break;
    case CLIENT_UPDATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        clientUpdated: action.payload,
        error: "",
      };
      break;
    case CLIENT_REQUEST_FAILED:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default client;
